import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Spin } from 'antd';
import { globalOp } from 'store/ducks/Global';
import AuthLayout from 'components/Layouts/AuthLayout';
import * as Styled from './VerifyLogin.styled';

const VerifyLogin: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [verifying, setVerifying] = useState(true);

  useEffect(() => {
    const token = searchParams.get('token');

    if (!token) {
      navigate('/');
      return;
    }

    globalOp
      .verifyLoginToken(token)
      .then(() => {
        setVerifying(false);
        navigate('/working_area');
      })
      .catch(() => {
        setVerifying(false);
        navigate('/');
      });
  }, [searchParams, navigate]);

  return (
    <AuthLayout>
      <Styled.Container>
        <Spin size='large' />
        <Styled.Message>
          {verifying ? 'Verifying your login...' : 'Redirecting...'}
        </Styled.Message>
      </Styled.Container>
    </AuthLayout>
  );
};

export default VerifyLogin;
